import moment from 'moment';
import { currencies } from '../constants/Currencies';
import CryptoJS from 'crypto-js';
import { ENVIRONMENT, PROPERTY_SERVICE_URL } from '../env/Configurations';

export const createIdFromLabel = (label) => {
  return label ? label.replace(/ /g, '_').toLowerCase() : '__';
};

export const generateRandomId = () => {
  return Math.floor(Math.random() * 100) + 1;
};

export const bytesToSize = (bytes) => {
  let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return '0 Byte';
  let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
};

export const bytesToMB = (bytes, decimals) => {
  if (!Number(bytes)) {
    return '0 Bytes';
  }

  const kbToBytes = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const index = Math.floor(Math.log(bytes) / Math.log(kbToBytes));
  const fileSize = bytes / Math.pow(kbToBytes, index);
  const truncatedSize = Math.floor(fileSize * Math.pow(10, dm)) / Math.pow(10, dm);
  return `${truncatedSize.toFixed(dm)} ${sizes[index]}`;
};

export const formatDateString = (unix) => {
  return moment.unix(unix).format('Do MMM YYYY');
};

export const sortCustomTime = (a, b) => {
  if (a.id > b.id) {
    return 1;
  } else {
    return -1;
  }
};

const sorter = {
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
  sunday: 7,
};

export const daysSort = (data) => {
  return data.sort(function sortByDay(a, b) {
    let day1 = a.toLowerCase();
    let day2 = b.toLowerCase();
    return sorter[day1] - sorter[day2];
  });
};

export const duplicateNumberInArray = (array) => {
  return array.some((element, index) => array.indexOf(element) !== index);
};

export const getTimeDifference = (time, startTime) => {
  const startDate = startTime ? moment.unix(startTime) : moment();
  const endDate = moment.unix(time);
  const timeDifference = endDate.diff(startDate, 'minutes');
  return timeDifference;
};

export const getCurrencyNameFromCode = (code) => {
  let currency = currencies.find((currency) => currency.code === code);
  return currency ?? currency.name ? currency.name : '';
};

// function for convert Invalid JSON Obj to Valid JSON Obj
export const parseObj = (Str) => {
  if (Str?.includes('=')) {
    let obj = Str.replaceAll(/{/g, '');
    obj = Str.replaceAll(/}/g, '');
    obj = obj.split(',');
    let urlStr = '',
      typeStr = '',
      nameStr = '';
    for (let i = 0; i < obj.length; i++) {
      if (obj[i].includes('url=')) {
        urlStr = obj[i];
      }
      if (obj[i].includes('type=')) {
        typeStr = obj[i];
      }
      if (obj[i].includes('name=')) {
        nameStr = obj[i];
      }
    }
    return {
      url: urlStr.split('=').slice(1).join('='),
      type: typeStr.split('=')[1],
      name: nameStr.split('=')[1],
    };
  } else {
    return {
      url: Str?.url,
      type: Str?.type,
      name: Str?.name,
    };
  }
};

export const camelize = (str) => {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, '');
};

export const appendFileExtensionIfMissing = (fileName = '', mimeType = '') => {
  if (!fileName || !mimeType) return fileName;
  if (/\.[^./\\]+$/.test(fileName)) return fileName;

  const mimeParts = mimeType.split('/');
  if (mimeParts.length < 2) return fileName;

  let extension = mimeParts[1].split('+')[0].toLowerCase();
  const extensionMap = {
    jpeg: 'jpg',
    'svg+xml': 'svg',
    plain: 'txt',
    'vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
    msword: 'doc',
    'vnd.ms-excel': 'xls',
    'vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
    'vnd.ms-powerpoint': 'ppt',
    'vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
    'x-icon': 'ico',
  };

  extension = extensionMap[extension] || extension;
  return extension ? `${fileName}.${extension}` : fileName;
};

export const defaultPdfHeader = '%PDF-';

// Function to check if the file is a valid PDF or not
export const checkPDFHeader = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const arrayBuffer = e?.target?.result;
      const uint8Array = new Uint8Array(arrayBuffer);
      const header = new TextDecoder()?.decode(uint8Array?.slice(0, 5));

      if (header === defaultPdfHeader) {
        resolve();
      } else {
        reject();
      }
    };
    reader.onerror = () => {
      reject();
    };
    reader?.readAsArrayBuffer(file);
  });
};

export const convertFileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      const base64String = reader.result.split(',')[1];
      resolve(base64String);
    };

    reader.onerror = (error) => {
      reject(error);
    };

    // Read the file as a data URL
    reader.readAsDataURL(file);
  });
};

export const logError = async (hotelId = null, methodName = '', message = '') => {
  //info: Since there are lot of API hits, this code is temporarily commented.Can be used in future.
  return true;

  // try {
  // const defaultHotelId = DEFAULT_HOTEL_ID;

  // await fetch(LOGGER_API_URL, {
  //   method: "POST",
  //   body: JSON.stringify({
  //     hotelId: hotelId ?? defaultHotelId,
  //     severity: "ERROR",
  //     channel: "CMS",
  //     message: methodName + " - " + message,
  //   }),
  // }).then((data) => {
  //   return data.json();
  // });
  // } catch (error) {
  //   if (ENVIRONMENT === "dev") {
  //     console.log(error?.message);
  //   }
  // }
};

export const today = new Date();

export const getValidValueOrNA = (value) => (value !== null && value !== undefined ? value : 'N/A');

export async function abortMultipartUpload(groupId, hotelId, uploadId) {
  try {
    const abortResponse = await fetch(`${PROPERTY_SERVICE_URL}/abortMultipartUpload`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        uploadId,
        groupId,
        hotelId,
      }),
    });

    const abortData = await abortResponse.json();
    console.log('Multipart upload aborted: ', abortData);
  } catch (abortError) {
    console.error('Error aborting multipart upload: ', abortError);
  }
}

export const completeMultipartUpload = async (groupId, hotelId, uploadId) => {
  try {
    const response = await fetch(`${PROPERTY_SERVICE_URL}/completeMultipartUpload`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        groupId,
        hotelId,
        uploadId,
      }),
    });

    return await response.json();
  } catch (error) {
    if (ENVIRONMENT === 'dev') {
      console.log(error?.message, 'error');
    }
    throw error;
  }
};

// Utility function to calculate file checksum (SHA-256)
export const calculateFileChecksum = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function (event) {
      try {
        const fileData = event.target.result;
        const hash = CryptoJS.SHA256(CryptoJS.lib.WordArray.create(fileData));
        resolve(hash.toString(CryptoJS.enc.Hex));
      } catch (error) {
        if (ENVIRONMENT === 'dev') {
          console.log(error?.message, 'error');
        }
        reject(error);
      }
    };
    reader.onerror = function (error) {
      reject(error);
    };
    reader.readAsArrayBuffer(file);
  });
};

export const CHUNK_SIZE = 2 * 1024 * 1024;

export const calculateTotalChunks = (fileSize) => {
  return Math.ceil(fileSize / CHUNK_SIZE);
};

export const getSelectedHotelName = (hotelList, hotelId) => {
  const hotelData = hotelList?.find((hotel) => hotel?.id === hotelId);
  return hotelData?.name;
};

export const getValidValueOrdefault = (value, defaultValue) => {
  return value !== null && value !== undefined ? value : defaultValue;
};

export const retrieveNoOfActivities = (category, mainlist) => {
  return mainlist?.filter((room) => room?.categoryId === category?.id)?.length;
};
export const formattedDetailsLabelData = (data) => {
  return data?.charAt(0)?.toUpperCase() + data?.slice(1)?.toLowerCase();
};

export const capitalizeFirstLetter = (s) => s && s[0].toUpperCase() + s.slice(1).toLowerCase();

export const sanitizeFileName = (fileName) => {
  if (!fileName) return fileName;
  return fileName.trim().replace(/\s{2,}/g, ' ');
};
